/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


/* Wyrdlore - swiping the product gallery selects that image's colour - 2026-10-18.
   Each product image is a colour's featured image, so the photo on screen and the
   colour that goes to the cart always match. Size stays as chosen. Images not tied
   to a colour are ignored. The theme rebuilds the gallery on every variant change,
   so this watches for the active slide rather than hooking one gallery instance. */
(function () {
  function init() {
    var main = document.getElementById('main');
    if (!main || !main.querySelector('.product-single__media')) return;

    var colourByMedia = null;
    var path = window.location.pathname.replace(/\/$/, '');
    fetch(path + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var idx = -1;
        product.options.forEach(function (o, i) {
          if (/^colou?r$/i.test(o.name)) idx = i;
        });
        if (idx < 0) return;
        colourByMedia = {};
        product.variants.forEach(function (v) {
          if (v.featured_media && !colourByMedia[v.featured_media.id]) {
            colourByMedia[v.featured_media.id] = v.options[idx];
          }
        });
      })
      .catch(function () {});

    function sync() {
      if (!colourByMedia) return;
      var el = main.querySelector('.product-single__media .swiper-slide-active [data-media-id]');
      var colour = el && colourByMedia[el.getAttribute('data-media-id')];
      if (!colour) return;
      var inputs = main.querySelectorAll('.product-form__swatch input[type="radio"]');
      for (var i = 0; i < inputs.length; i++) {
        var input = inputs[i];
        if (/^colou?r$/i.test(input.name) && input.value === colour) {
          if (!input.checked) input.click();
          return;
        }
      }
    }

    var timer = null;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (t.classList && t.classList.contains('swiper-slide-active')) {
          clearTimeout(timer);
          timer = setTimeout(sync, 300);
          return;
        }
      }
    }).observe(main, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Wyrdlore - footer "The Society Dispatch" sign-up goes to Klaviyo - 2026-10-21.
   The theme's footer form only creates a Shopify customer, which Klaviyo files on
   the checkout list, so footer sign-ups never got the welcome series or the 15% code.
   This sends the email straight to the Klaviyo "Email popup" list (Wxhyn5), the list
   that starts the welcome series. If Klaviyo can't be reached, the form submits the
   old way, so no sign-up is lost. Listens in the capture phase and stops the event,
   because Shopify's hCaptcha script on customer forms calls form.submit() itself
   and ignores preventDefault. On success it also identifies the visitor to Klaviyo's
   onsite tracking (added 2026-10-21), so the sign-up pop-up stops showing to them
   and browse/site abandonment can recognise them. */
(function () {
  var KLAVIYO_COMPANY = 'RWCidj';
  var KLAVIYO_LIST = 'Wxhyn5';
  var SOURCE = 'Footer - The Society Dispatch';
  var THANKS = 'You’re on the list. Your first letter is on its way.';

  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== 'footer-contacts-newsletter') return;
    if (form.getAttribute('data-wyrd-fallback') === '1') return;

    var input = form.querySelector('input[type="email"]');
    if (!input) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var email = (input.value || '').trim();
    if (!email || !input.checkValidity()) {
      input.reportValidity();
      return;
    }

    var button = form.querySelector('button[type="submit"]');
    if (button) button.disabled = true;

    function fallback() {
      if (button) button.disabled = false;
      form.setAttribute('data-wyrd-fallback', '1');
      if (form.requestSubmit) form.requestSubmit(button || undefined);
      else form.submit();
    }

    fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + KLAVIYO_COMPANY, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: SOURCE,
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST } } }
        }
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('klaviyo ' + r.status);
        try {
          if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
            window.klaviyo.identify({ email: email });
          } else if (window._learnq && window._learnq.push) {
            window._learnq.push(['identify', { $email: email }]);
          }
        } catch (err) {}
        var msg = document.createElement('div');
        msg.className = 'newsletter__form-message newsletter__form-message--footer';
        var h = document.createElement('h3');
        h.className = 'newsletter__form-message__text f-family--body f-caps--false';
        h.textContent = THANKS;
        msg.appendChild(h);
        form.innerHTML = '';
        form.appendChild(msg);
      })
      .catch(fallback);
  }, true);
})();
